// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class FeatureFlagAreas {
  
    public static readonly GLOBAL: string = 'GLOBAL';
    public static readonly SECONDARY: string = 'SECONDARY';
    public static readonly POST_SECONDARY: string = 'POST_SECONDARY';
}
